export default __webpack_public_path__ + "static/media/116_arak_kawai_0001.c569289e.png";